import { default as AntTag, TagProps as AntTagProps } from "antd/lib/tag";

import React from "react";

export function Tag({ children, ...props }: AntTagProps) {
  return <AntTag {...props}>{children}</AntTag>;
}
